import { render } from "./PropertySelfService.vue?vue&type=template&id=cd50190e&scoped=true"
import script from "./PropertySelfService.vue?vue&type=script&lang=js"
export * from "./PropertySelfService.vue?vue&type=script&lang=js"

import "./PropertySelfService.vue?vue&type=style&index=0&id=cd50190e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd50190e"]])

export default __exports__